import * as React from 'react'
const MoreIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M10 12a2 2 0 10-2-2 2 2 0 002 2zm6 0a2 2 0 10-2-2 2 2 0 002 2zM4 12a2 2 0 10-2-2 2 2 0 002 2z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default MoreIcon